<template>
  <label
    class="button-toggle"
    :class="[
      toggleClass,
      type,
      {
        disabled,
        'form-switch': type === 'switch',
      },
    ]"
  >
    <span
      v-if="label && labelLeft"
      class="label left"
      :class="{ blue: value !== null, }"
    >
      {{ label }}
    </span>
    <template v-if="type === 'radio'">
      <input
        type="radio"
        :name="name"
        :value="inputValue"
        :checked="value === inputValue"
        :disabled="disabled"
        @change="$emit('change', $event.target.value)"
      />
      <UilCircle
        v-if="value !== inputValue"
        class="icon"
        size="24"
      />
      <UisCheckCircle
        v-else
        class="icon"
        size="24"
      />
    </template>
    <input
      v-else-if="type === 'switch'"
      class="form-check-input left"
      :class="switchClass"
      type="checkbox"
      role="switch"
      :name="name"
      :checked="switchValue"
      :disabled="disabled"
      @click="switchValue = !switchValue"
    />
    <span
      v-if="label && !labelLeft"
      class="label right"
      :class="{ blue: value !== null, }"
    >
      {{ label }}
    </span>
  </label>
</template>

<script>
import { UilCircle } from "@iconscout/vue-unicons";
import { UisCheckCircle } from "@iconscout/vue-unicons-solid";

/**
 * Affiche un bouton radio ou un switch.
 */
export default {
  name: "ButtonToggle",
  components: {
    UilCircle,
    UisCheckCircle,
  },
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    /**
     * Valeur du bouton définissant son état.
     */
    value: {
      type: [String, Boolean],
      default: null,
    },
    /**
     * Type de bouton.
     */
    type: {
      type: String,
      default: "radio",
      validator: (value) => ["radio", "switch"].includes(value),
    },
    /**
     * Texte dans le bouton.
     */
    label: {
      type: String,
      default: "",
    },
    /**
     * Nom du groupe des inputs.
     */
    name: {
      type: String,
      required: true,
    },
    /**
     * Value de l'input (type "radio" uniquement).
     */
    inputValue: {
      type: String,
      default: "",
    },
    /**
     * Désactive le changement de valeur.
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * Si le label est à gauche.
     */
    labelLeft: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    /**
     * Déclenché au changement d'état du bouton.
     * @param {Boolean} - Peut être `null`.
     */
    "change",
  ],
  computed: {
    switchValue: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit("change", newVal);
      },
    },
    toggleClass() {
      const condition = this.value === this.inputValue || (typeof (this.value) === "boolean" && this.value);
      return condition ? "checked" : "empty";
    },
    switchClass() {
      switch (this.switchValue) {
        case true:
          return "positive";

        case false:
          return "negative";

        default:
          return "empty";
      }
    },
  },
};
</script>

<style lang="scss">
@use "../../assets/styles/components/buttons/button_toggle.scss";
</style>
